import type {
  KrigingParams,
  MinimalCurvatureParams,
  MovingAverageParams,
  SequentialConvergenceParams,
} from '@core/core/types'

import type { MapBuilderGroup, MapBuilderItem } from './types'

export const mpGroups: MapBuilderGroup[] = [
  { id: 'input', title: 'Входные данные' },
  { id: 'settings', title: 'Настройки расчёта' },
  { id: 'results', title: 'Результаты' },
]

export const mpItems: MapBuilderItem[] = [
  { id: 'object', groupId: 'input', label: 'Объект' },
  { id: 'geometry', groupId: 'settings', label: 'Геометрия' },
  { id: 'algorithms', groupId: 'settings', label: 'Алгоритм' },
  { id: 'correction', groupId: 'settings', label: 'Корректировка' },
  /* TODO Раскомментировать, когда будет готов функционал
   { id: 'additionalObjects', groupId: 'settings', label: 'Доп. ввод. объекты', disabled: true }, */
  { id: 'map', groupId: 'results', label: 'Карта' },
]

export const krigingDefaultField: KrigingParams = {
  nugget: 0.0001,
  sill: 1,
  azimuth: 0,
  minRange: 5000,
  maxRange: 5000,
  variogramm: 'Gaussian',
  method: 'Simple',
}

export const sequentialConvergenceDefaultField: SequentialConvergenceParams = {
  initNxNy: 2,
  isBilinear: true,
  calculation: 'Fast',
  kernelSize3X3: true,
}

export const minimalCurvatureDefaultField: MinimalCurvatureParams = {
  interpolationMethod: 'MeanValue',
  weightCoefficient: 'Equals',
  extrapolationMethod: 'MinimalCurvature',
  maxDiscrepancy: 0.001,
  iterationsCount: 1000,
}

export const movingAverageDefaultField: MovingAverageParams = {
  weightCoefficient: 'Equals',
  ellipseBigRadius: 3000,
  ellipseSmallRadius: 3000,
  anisotropyAngle: 0,
  neighborsCount: 1,
}

export const MAX_GRID_NODES = 6_000_000
